import { ReferrerApp } from "./types/referrerApp";

import parseReferrerQueryParams from "./util/parseReferrerQueryParams";
import isValidReferrer from "./util/isValidReferrer";
import {
  getReferrerFromSession,
  saveReferrerToSession,
} from "./util/referrerSessionStorage";

export const handleReferrer = (searchString: string) => {
  const { referrer, name } = parseReferrerQueryParams(searchString);

  if (!referrer || !isValidReferrer(referrer)) return;

  saveReferrerToSession({
    name,
    url: referrer,
  });
};

export const getReferrer = (): ReferrerApp => {
  const savedValue = getReferrerFromSession();

  if (!savedValue) {
    return {
      name: "",
      url: "",
    };
  }

  return JSON.parse(savedValue);
};
